/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Crossfit_TermsInputs */

const en_service_type_crossfit_terms = /** @type {(inputs: Service_Type_Crossfit_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`crossfit, cross training, box, wod`)
};

const pl_service_type_crossfit_terms = /** @type {(inputs: Service_Type_Crossfit_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`crossfit, cross trening, box, wod`)
};

/**
* | output |
* | --- |
* | "crossfit, cross training, box, wod" |
*
* @param {Service_Type_Crossfit_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_crossfit_terms = /** @type {((inputs?: Service_Type_Crossfit_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Crossfit_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_crossfit_terms(inputs)
	return en_service_type_crossfit_terms(inputs)
});